/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Storyblok_DatasourceEntriesResponse } from '../models/Storyblok_DatasourceEntriesResponse';
import type { Storyblok_DatasourceResponse } from '../models/Storyblok_DatasourceResponse';
import type { Storyblok_DatasourcesResponse } from '../models/Storyblok_DatasourcesResponse';
import type { Storyblok_LinkResponse } from '../models/Storyblok_LinkResponse';
import type { Storyblok_LinksResponse } from '../models/Storyblok_LinksResponse';
import type { Storyblok_StoriesResponse } from '../models/Storyblok_StoriesResponse';
import type { Storyblok_StoryResponse } from '../models/Storyblok_StoryResponse';
import type { Storyblok_TagsResponse } from '../models/Storyblok_TagsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoryblokContentDeliveryService {
    /**
     * Retrieve a list of Stories from Storyblok.
     * @returns Storyblok_StoriesResponse Successfully retrieved the list of stories from Storyblok.
     * @throws ApiError
     */
    public static getStoriesFromStoryblok({
        apiVersion = 1,
        perPage = 25,
        page = 1,
        startsWith,
        sortBy,
        bySlugs,
        excludingSlugs,
        publishedAtGt,
        publishedAtLt,
        inWorkflowStages,
        contentType,
        firstPublishedAtGt,
        firstPublishedAtLt,
        level,
        resolveRelations,
        excludingIds,
        byUuids,
        byUuidsOrdered,
        withTag,
        isStartpage,
        resolveLinks,
        fromRelease,
        fallbackLang,
        language,
        filterQuery,
        excludingFields,
        resolveAssets,
    }: {
        apiVersion?: number,
        /**
         * The number of items per page.
         */
        perPage?: number,
        /**
         * The page number to return.
         */
        page?: number,
        /**
         * Filter by full_slug. Can be used to retrieve all items form a specific folder. Examples: starts_with=de/beitraege, starts_with=en/posts.
         */
        startsWith?: string,
        /**
         * Sort entries by specific attribute and order with content.YOUR_FIELD:asc and content.YOUR_FIELD:desc. Possible values are all attributes of the entry and all fields of your content type inside content with the dot as seperator. Example: position:desc, content.your_custom_field:asc, content.field_type_xy.field_xy:asc, created_at:desc. If you want to use the sorting provided by the user in the Storyblok admin interface you need to use position:desc. By default all custom fields are sorted as strings. To sort custom fields with numeric values you need to provide the type information (float or int) like following: content.YOUR_FIELD:asc:float or content.YOUR_FIELD:asc:int
         */
        sortBy?: string,
        /**
         * Get stories by comma separated full_slug. You can also specify wildcards with *. Examples: by_slugs=authors/john,authors/max, by_slugs=authors*,articles*
         */
        bySlugs?: string,
        /**
         * Exclude stories specifying comma separated values of full_slug. You can also specify wildcards with *. Examples: excluding_slugs=authors/john,authors/max, excluding_slugs=authors*
         */
        excludingSlugs?: string,
        /**
         * After a specific published date (Format: 2018-03-03 10:00)
         */
        publishedAtGt?: string,
        /**
         * Before a specific published date (Format: 2018-03-03 10:00)
         */
        publishedAtLt?: string,
        /**
         * Comma separated list of ids. You can get the ids of the workflow stages using the Management API Example: in_workflow_stages=812,186
         */
        inWorkflowStages?: string,
        /**
         * Filter by specific content type. Example: content_type=author
         */
        contentType?: string,
        /**
         * After a specific first published date (Format: 2018-03-03 10:00)
         */
        firstPublishedAtGt?: string,
        /**
         * Before a specific first published date (Format: 2018-03-03 10:00)
         */
        firstPublishedAtLt?: string,
        /**
         * Filter by specific folder level. Useful for getting items for navigations. Example: level=2
         */
        level?: number,
        /**
         * Resolve relationships to other Stories of a multi-option or single-option field-type. Provide the component name and the field key as comma separated string. Resolved relations can be found in root of response under the property rels. The limit of resolved relationships is 100 Stories. You can't use this filter to resolve relations of resolved entries (eg. nested relationship resolving). Example: resolve_relations=page.author,page.categories;
         */
        resolveRelations?: string,
        /**
         * Exclude stories by comma separated numeric ids. Example: excluding_ids=101231,9101231
         */
        excludingIds?: string,
        /**
         * Get stories by comma separated uuid. To get a specific language you need to combine it with the parameter language=en (replace en with your langauge) Example: by_uuids=9aa72a2f-04ae-48df-b71f-25f53044dc97,84550816-245d-4fe6-8ae8-b633d4a328f4
         */
        byUuids?: string,
        /**
         * Get stories by comma separated uuid ordered by the sequence provided in the parameter value. To get a specific language you need to combine this filter with starts_with=en* (replace en with your langauge) Example: by_uuids_ordered=9aa72a2f-04ae-48df-b71f-25f53044dc97,84550816-245d-4fe6-8ae8-b633d4a328f4
         */
        byUuidsOrdered?: string,
        /**
         * Filter by specific tag(s). Use comma to filter by multiple tags. Examples: with_tag=featured,home
         */
        withTag?: string,
        /**
         * Filter by folder startpage. Use is_startpage=1 to only return startpages and is_startpage=0 to exclude startpages from the result.
         */
        isStartpage?: '0' | '1' | 'true' | 'false',
        /**
         * The parameter resolve_links will automatically resolve internal links of the multilink field type. Resolved links can be found in the links property of the response. Possible values are story, url, and link. You can resolve entries going one level deep.
         */
        resolveLinks?: 'story' | 'url' | 'link',
        /**
         * Access version of specific release by release id
         */
        fromRelease?: string,
        /**
         * Define a custom fallback language. By default the fallback language is the one defined in the space settings
         */
        fallbackLang?: string,
        /**
         * Choose the language of the content. Example language=de
         */
        language?: string,
        /**
         * Filter by specific attribute(s) of your content type - it will not work for default Story properties. The filter query parameter needs to contain the query operation key. Separate the values by a comma , to filter by multiple values.
         * filter_query[ATTRIBUTE][OPERATION]=VALUE,...
         * Following filter operations OPERATION are available: is - Checks for empty or not empty values and booleans. For strings the value can be empty or not_empty. For arrays use empty_array or not_empty_array. For booleans use true or false. Additionally you can check for null values with null and not_null
         * in - Exact match of one of the provided values
         * not_in - Does not contain the given value
         * like - Does contain the given value with a wildcard * search
         * not_like - Does not contain the given value with a wildcard * search
         * all_in_array - Contains all of the values of an array value
         * any_in_array - Contains any of the values of an array value
         * gt_date - Greater than date (Format: 2018-03-03 10:00)
         * lt_date - Less than date
         * gt_int - Greater than integer value
         * lt_int - Less than integer value.
         * gt_float - Greater than float value
         * lt_float - Less than float value.
         */
        filterQuery?: Record<string, any>,
        /**
         * Exclude specific fields of your content type by comma seperated names. Example: excluding_fields=title,content (Only the first (root) level fields are excluded, not the nested attributes)
         */
        excludingFields?: string,
        /**
         * If the value is 1 it will resolve assets in the content and include the meta information (only available in the Teams plan and above)
         */
        resolveAssets?: '1',
    }): CancelablePromise<Storyblok_StoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/stories',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'per_page': perPage,
                'page': page,
                'starts_with': startsWith,
                'sort_by': sortBy,
                'by_slugs': bySlugs,
                'excluding_slugs': excludingSlugs,
                'published_at_gt': publishedAtGt,
                'published_at_lt': publishedAtLt,
                'in_workflow_stages': inWorkflowStages,
                'content_type': contentType,
                'first_published_at_gt': firstPublishedAtGt,
                'first_published_at_lt': firstPublishedAtLt,
                'level': level,
                'resolve_relations': resolveRelations,
                'excluding_ids': excludingIds,
                'by_uuids': byUuids,
                'by_uuids_ordered': byUuidsOrdered,
                'with_tag': withTag,
                'is_startpage': isStartpage,
                'resolve_links': resolveLinks,
                'from_release': fromRelease,
                'fallback_lang': fallbackLang,
                'language': language,
                'filter_query': filterQuery,
                'excluding_fields': excludingFields,
                'resolve_assets': resolveAssets,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
    /**
     * Retrieve a Storyblok story by full slug, ID, or UUID.
     * @returns Storyblok_StoryResponse Successfully retrieved the story from Storyblok.
     * @throws ApiError
     */
    public static getStoryFromStoryblok({
        identifier,
        apiVersion = 1,
        findBy,
        resolveLinks,
        resolveRelations,
        fromRelease,
        language,
        fallbackLang,
        resolveAssets,
    }: {
        /**
         * The full slug, ID or UUID of the entry.
         */
        identifier: (string | number),
        apiVersion?: number,
        findBy?: 'uuid',
        /**
         * The parameter resolve_links will automatically resolve internal links of the multilink field type. Resolved links can be found in the links property of the response. Possible values are story, url, and link. You can resolve entries going one level deep.
         */
        resolveLinks?: 'story' | 'url' | 'link',
        /**
         * Resolve relationships to other Stories of a multi-option or single-option field-type. Provide the component name and the field key as comma separated string. Resolved relations can be found in root of response under the property rels. The limit of resolved relationships is 100 Stories. You can't use this filter to resolve relations of resolved entries (eg. nested relationship resolving). Example: resolve_relations=page.author,page.categories;
         */
        resolveRelations?: string,
        /**
         * Access version of specific release by release id
         */
        fromRelease?: string,
        /**
         * Choose the language of the content. Example language=de
         */
        language?: string,
        /**
         * Define a custom fallback language. By default the fallback language is the one defined in the space settings
         */
        fallbackLang?: string,
        /**
         * If the value is 1 it will resolve assets in the content and include the meta information (only available in the Teams plan and above)
         */
        resolveAssets?: '1',
    }): CancelablePromise<Storyblok_StoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/stories/{identifier}',
            path: {
                'apiVersion': apiVersion,
                'identifier': identifier,
            },
            query: {
                'find_by': findBy,
                'resolve_links': resolveLinks,
                'resolve_relations': resolveRelations,
                'from_release': fromRelease,
                'language': language,
                'fallback_lang': fallbackLang,
                'resolve_assets': resolveAssets,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
    /**
     * Retrieve a list of Datasources from Storyblok.
     * @returns Storyblok_DatasourcesResponse Successfully retrieved the list of datasources from Storyblok.
     * @throws ApiError
     */
    public static getDatasourcesFromStoryblok({
        apiVersion = 1,
        perPage = 25,
        page = 1,
    }: {
        apiVersion?: number,
        /**
         * The number of items per page.
         */
        perPage?: number,
        /**
         * The page number to return.
         */
        page?: number,
    }): CancelablePromise<Storyblok_DatasourcesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/datasources',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'per_page': perPage,
                'page': page,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
    /**
     * Retrieve a Storyblok datasource by full slug or ID.
     * @returns Storyblok_DatasourceResponse Successfully retrieved the datasource from Storyblok.
     * @throws ApiError
     */
    public static getDatasourceFromStoryblok({
        identifier,
        apiVersion = 1,
    }: {
        /**
         * The full slug, ID or UUID of the entry.
         */
        identifier: (string | number),
        apiVersion?: number,
    }): CancelablePromise<Storyblok_DatasourceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/datasources/{identifier}',
            path: {
                'apiVersion': apiVersion,
                'identifier': identifier,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
    /**
     * Retrieve a list of Datasource entries from Storyblok.
     * @returns Storyblok_DatasourceEntriesResponse Successfully retrieved the list of datasource entries from Storyblok.
     * @throws ApiError
     */
    public static getDatasourceEntriesFromStoryblok({
        apiVersion = 1,
        perPage = 25,
        page = 1,
    }: {
        apiVersion?: number,
        /**
         * The number of items per page.
         */
        perPage?: number,
        /**
         * The page number to return.
         */
        page?: number,
    }): CancelablePromise<Storyblok_DatasourceEntriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/datasource_entries',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'per_page': perPage,
                'page': page,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
    /**
     * Retrieve a list of links from Storyblok.
     * @returns Storyblok_LinksResponse Successfully retrieved the list of links from Storyblok.
     * @throws ApiError
     */
    public static getLinksFromStoryblok({
        apiVersion = 1,
        paginated,
        perPage = 25,
        page = 1,
        startsWith,
    }: {
        apiVersion?: number,
        /**
         * Specify whether the response should be paginated.
         */
        paginated?: boolean,
        /**
         * The number of items per page.
         */
        perPage?: number,
        /**
         * The page number to return.
         */
        page?: number,
        /**
         * Filter by full_slug. Can be used to retrieve all items form a specific folder. Examples: starts_with=de/beitraege, starts_with=en/posts.
         */
        startsWith?: string,
    }): CancelablePromise<Storyblok_LinksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/links',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'paginated': paginated,
                'per_page': perPage,
                'page': page,
                'starts_with': startsWith,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
    /**
     * Retrieve a Storyblok link by full slug or ID.
     * @returns Storyblok_LinkResponse Successfully retrieved the datasource from Storyblok.
     * @throws ApiError
     */
    public static getLinkFromStoryblok({
        identifier,
        apiVersion = 1,
    }: {
        /**
         * The full slug, ID or UUID of the entry.
         */
        identifier: (string | number),
        apiVersion?: number,
    }): CancelablePromise<Storyblok_LinkResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/links/{identifier}',
            path: {
                'apiVersion': apiVersion,
                'identifier': identifier,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
    /**
     * Retrieve a list of tags from Storyblok.
     * @returns Storyblok_TagsResponse Successfully retrieved the list of tags from Storyblok.
     * @throws ApiError
     */
    public static getTagsFromStoryblok({
        apiVersion = 1,
        startsWith,
    }: {
        apiVersion?: number,
        /**
         * Filter by full_slug. Can be used to retrieve all items form a specific folder. Examples: starts_with=de/beitraege, starts_with=en/posts.
         */
        startsWith?: string,
    }): CancelablePromise<Storyblok_TagsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/tags',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'starts_with': startsWith,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
}
